import { gsap, ScrollTrigger } from "./globals.js";

document.addEventListener("DOMContentLoaded", () => {
  const textFadeSection = document.querySelector(".text-fade");

  if (textFadeSection) {
    const rows = textFadeSection.querySelectorAll(".text-fade__text-wrap__row");
    const lineSpans = textFadeSection.querySelectorAll(".text-fade__pagination .line span");

    const masterTl = gsap.timeline({
      scrollTrigger: {
        trigger: textFadeSection,
        start: "top top",
        end: () => `+=${rows.length * 1000}`,
        scrub: 2,
        pin: true,
        anticipatePin: 1,
      }
    });

    masterTl.addLabel("textStart");

    rows.forEach((row, index) => {

      const chars = row.querySelectorAll(".char");
      const label = `textStep${index + 1}`;
      const isLast = index === rows.length - 1;

      const fadeInDuration = isLast ? 10 : 3;
      const staggerAmount = isLast ? 0.35 : 0.05;

      masterTl.addLabel(label);

      // Fade in heading characters
      masterTl.fromTo(chars, {
        opacity: 0,
        y: '5%',
        willChange: "opacity"
      }, {
        opacity: 1,
        y: 0,
        stagger: staggerAmount,
        duration: fadeInDuration
      }, label + "-=2");

      // Pagination line animation
      if (lineSpans[index]) {
        masterTl.to(lineSpans[index], {
          scaleX: 1,
          transformOrigin: "left",
          duration: 3,
          ease: "linear"
        }, label);
      }

      // Fade out whole row if not last
      if (!isLast) {
        masterTl.to(row, {
          opacity: 0,
          scale: 1.2,
          duration: 10,
          ease: "power1.out"
        });
      }
    });
  }
});
